import { Link } from 'react-router-dom'
import type { BlogPost } from '@/data/blog'

interface BlogPostListProps {
  posts: BlogPost[]
  /** Message rendered when there are no posts to show. */
  emptyMessage?: string
}

/**
 * Renders the shared blog archive list markup. Used by the `/blog` listing and
 * the dynamic category/tag archive pages so all three stay visually in sync.
 */
export function BlogPostList({ posts, emptyMessage = 'No blog posts found.' }: BlogPostListProps) {
  if (!posts.length) {
    return (
      <div className="blog-posts">
        <p className="text-center">{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="blog-posts">
      {posts.map((post) => (
        <div className="single-blog-post" key={post.slug}>
          <div className="post-image">
            <Link to={`/blog/${post.slug}`}>
              <figure>
                <img src={post.image} alt={post.title} />
              </figure>
            </Link>
          </div>
          <div className="post-content">
            <ul className="post-meta">
              <li>
                <a href="#">
                  <i className="fa-solid fa-user"></i>
                  <span>By: {post.author}</span>
                </a>
              </li>
              <li>
                <i className="fa-solid fa-calendar-days"></i>
                <span>{post.date}</span>
              </li>
            </ul>
            <h2>
              <Link to={`/blog/${post.slug}`}>{post.title}</Link>
            </h2>
            <p>{post.excerpt}</p>
            <div className="blog-list-button">
              <Link to={`/blog/${post.slug}`} className="theme-button style-1" aria-label="Read Mores">
                <span data-text="Read Mores">Read Mores</span>
                <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
